<template>
    <div :class="[`${type}-balloon`]">
        <div
            class="om-balloon-backdrop"
            @click="$emit('close')"
            @touchstart="$emit('close')"
        />
        <OfficesBalloonContent
            :balloon-data="balloonData"
            :balloons-total="balloonsTotal"
            :balloon-index="balloonIndex"
            :type="type"
            @close="$emit('close')"
            @switch="$emit('switch', $event)"
        />
    </div>
</template>

<script>
import {defineComponent} from 'vue';

import OfficesBalloonContent from '@/components/Pages/About/Offices/OfficesBalloonContent.vue';

export default defineComponent({
    name: 'OfficesMapBalloon',
    components: {
        OfficesBalloonContent,
    },
    props: {
        balloonData: {
            type: Object,
            required: true,
        },
        type: {
            type: String,
            default: () => '',
        },
        balloonsTotal: {
            type: Number,
            default: () => 1,
        },
        balloonIndex: {
            type: Number,
            default: () => 0,
        },
    },
});
</script>

<style lang="scss">
@import '@/assets/styles/components/about/offices/offices-balloon';
</style>
